export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgIi4uL2ltYWdlcy9zbGljay5zdmciOw=="